const ShowHideColumns = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 37.01 28.302"
    fill="inherit"
  >
    <g id="two-rows-and-three-columns-layout" transform="translate(0 0)">
      <g id="view-module" transform="translate(0 0)">
        <path
          id="Path_29"
          data-name="Path 29"
          d="M0,64.062H10.885V51H0ZM0,79.3H10.885V66.24H0Zm13.062,0H23.948V66.24H13.062Zm13.062,0H37.01V66.24H26.125ZM13.062,64.062H23.948V51H13.062ZM26.125,51V64.062H37.01V51Z"
          transform="translate(0 -51)"
          fill="inherit"
        />
      </g>
    </g>
  </svg>
);

export default ShowHideColumns;
